import { ExamResultTable } from './ExamResultTable';
export default ExamResultTable;
